
  import { defineComponent, PropType } from 'vue';

  import ContextMenu from '@/common/components/redesigned/ContextMenu/ContextMenu.vue';
  import ContextMenuItem from '@/common/components/redesigned/ContextMenu/ContextMenuItem.vue';

  import type { TAdditionalMenuConfig } from './types';
  import { GlobalContextMenuActions, LocalContextMenuActions } from './types';

  export default defineComponent({
    name: 'CombinedContextMenu',
    components: {
      ContextMenu,
      ContextMenuItem,
    },
    props: {
      isVisible: {
        type: Boolean,
        default: false,
      },
      isFlatTree: {
        type: Boolean,
        default: false,
      },
      position: {
        type: Object as () => { top: number; left: number },
        required: true,
      },
      additionalMenu: {
        type: Array as PropType<TAdditionalMenuConfig[]>,
        default: () => [],
      },
      isSingleMode: {
        type: Boolean,
        required: true,
      },
      isShowChildrenActions: {
        type: Boolean,
        default: false,
      },
    },
    emits: ['globalAction', 'localAction', 'close'],
    methods: {
      handleClose() {
        this.$emit('close');
      },
      handleGlobalExpandAll() {
        this.emitGlobal(GlobalContextMenuActions.EXPAND_ALL);
      },
      handleGlobalCollapseAll() {
        this.emitGlobal(GlobalContextMenuActions.COLLAPSE_ALL);
      },
      handleGlobalSelectAll() {
        this.emitGlobal(GlobalContextMenuActions.SELECT_ALL);
      },
      handleGlobalUnselectAll() {
        this.emitGlobal(GlobalContextMenuActions.UNSELECT_ALL);
      },
      emitGlobal(action: GlobalContextMenuActions) {
        this.$emit('globalAction', action);
        this.$emit('close');
      },
      handleLocalSelectAllChildrenByLevel() {
        this.emitLocal(LocalContextMenuActions.SELECT_ALL_CHILDREN_BY_LEVEL);
      },
      handleLocalSelectAllChildren() {
        this.emitLocal(LocalContextMenuActions.SELECT_ALL_CHILDREN);
      },
      handleLocalUnselectAllChildren() {
        this.emitLocal(LocalContextMenuActions.UNSELECT_ALL_CHILDREN);
      },
      emitLocal(action: LocalContextMenuActions) {
        this.$emit('localAction', action);
        this.$emit('close');
      },
    },
  });
